import { render, staticRenderFns } from "./TableAll.vue?vue&type=template&id=2c8e457e&scoped=true&"
import script from "./TableAll.vue?vue&type=script&lang=ts&"
export * from "./TableAll.vue?vue&type=script&lang=ts&"
import style0 from "./TableAll.vue?vue&type=style&index=0&id=2c8e457e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8e457e",
  null
  
)

export default component.exports